import React from 'react'
import { Box, Typography, makeStyles } from '@material-ui/core'
import { AgentCommissionPreview } from '../types'
import { caseCountLabel, money, statusLabel } from '../utils'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2)
  },
  item: {
    border: '1px solid #e2e5e9',
    borderRadius: 6,
    padding: theme.spacing(1.25, 1.5),
    background: '#fff'
  },
  primary: { borderColor: '#f2b27f', background: '#fff8f2', '& $value': { color: '#c95300' } },
  positive: { borderColor: '#b9ddc3', background: '#f4faf6', '& $value': { color: '#237a3b' } },
  label: { color: '#68707b', fontWeight: 600, textTransform: 'uppercase', fontSize: 11 },
  value: { color: '#20242a', fontWeight: 700, marginTop: 3, fontVariantNumeric: 'tabular-nums' },
  detail: { color: '#68707b', display: 'block', marginTop: 2 },
  '@media (max-width: 600px)': { root: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' } }
}))

interface KpiProps {
  label: string
  value: string
  detail?: string
  className?: string
}

const Kpi: React.FC<KpiProps> = ({ label, value, detail, className = '' }) => {
  const classes = useStyles()
  return (
    <Box className={`${classes.item} ${className}`}>
      <Typography className={classes.label} variant="caption">
        {label}
      </Typography>
      <Typography className={classes.value} variant="h6">
        {value}
      </Typography>
      {detail ? (
        <Typography className={classes.detail} variant="caption">
          {detail}
        </Typography>
      ) : null}
    </Box>
  )
}

const AgentCommissionKpis: React.FC<{ preview: AgentCommissionPreview }> = ({ preview }) => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <Kpi label={caseCountLabel(preview.period)} value={String(preview.registeredCaseCount)} />
      <Kpi
        label="Promedio diario"
        value={preview.averageCasesPerBusinessDay.toFixed(1)}
        detail={`${preview.businessDayCount} días hábiles`}
      />
      <Kpi
        label="Meta alcanzada"
        value={preview.goalLevel ? `Meta ${preview.goalLevel}` : 'Sin meta'}
        detail={preview.casesToNextGoal ? `Faltan ${preview.casesToNextGoal} casos` : 'Meta máxima alcanzada'}
        className={preview.goalLevel ? classes.positive : ''}
      />
      <Kpi
        label="Comisión causada"
        value={money(preview.commissionAmount)}
        detail={statusLabel(preview.status)}
        className={classes.primary}
      />
    </Box>
  )
}

export default AgentCommissionKpis
